export const parseApiError = (error) => {
  try {
    const errorData = JSON.parse(error.message);
    if (errorData.detail) {
      if (Array.isArray(errorData.detail)) {
        return errorData.detail
          .map((err) => {
            const field = err.loc[1] || 'general';
            const formattedField = field
              .replace(/_/g, ' ')
              .replace(/\b\w/g, (l) => l.toUpperCase());
            return `${formattedField}: ${err.msg}`;
          })
          .join('\n');
      }
      return errorData.detail;
    }
  } catch (e) {
    /* Intentionally empty */
  }
  // Fallback to the original error message if parsing fails
  return error.message || 'An unexpected error occurred.';
};
